import { Component, EventEmitter, Input, OnInit, AfterViewChecked, Output, SimpleChanges } from '@angular/core';
import { heightContentAnimation, visibleContentAnimation } from '../../../animations';
import { SharedService } from '../../../services/shared.service';
import Swal from 'sweetalert2';
import { FamilyGroupBySegmentModelDTO, FamilyGroupSelectionDTO, FamilySelectionDTO, PuntoapuntoFamilyDTO, SegmentGroupSelectionDTO } from 'src/app/models/renault-puntoapunto-local-campaign-segmentation-dto';
import { PuntoapuntoLocalCampaignSegmentationService } from 'src/app/services/puntoapunto-local-campaign-segmentation.service';

@Component({
  selector: 'app-family-selector',
  templateUrl: './family-selector.component.html',
  animations: [visibleContentAnimation, heightContentAnimation]
})

export class FamilySelectorComponent implements OnInit, AfterViewChecked {

  @Input() ShowPoints: boolean = false;
  @Input() selectedFamilies: FamilyGroupSelectionDTO[];
  @Input() selectedSegments: SegmentGroupSelectionDTO[];

  model: FamilyGroupBySegmentModelDTO[];
  modelSearch: FamilyGroupBySegmentModelDTO[];
  rolData: any[] = [];
  @Input() familyFind: string = '';
  @Input() isUnits: boolean = false;

  textCantidadUnidad = "";

  activeTabsIds: string[] = [];


  @Output() onFamilySelected = new EventEmitter<FamilyGroupSelectionDTO[]>();
  @Output() onSegmentSelected = new EventEmitter<SegmentGroupSelectionDTO[]>();


  addSegmentFormIsVisible: boolean = false;

  constructor(
    private service: PuntoapuntoLocalCampaignSegmentationService,
    private sharedService: SharedService
  ) { }

  ngOnInit(): void {

    this.SetTextCantidadUnidad();
    this.service.getFamilyGroupBySegment().subscribe(res => {
      this.model = res;
      this.modelSearch = res;
    });
  }

  ngAfterViewChecked() {

    if (this.selectedFamilies.length > 0 && this.activeTabsIds.length < 1) {
      this.setActiveTabsIds();
    }
  
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.familyFind && changes.familyFind.currentValue != '' && changes.familyFind.previousValue != changes.familyFind.currentValue) {
      this.searchFamily();
    }

    if (changes.isUnits && changes.isUnits.previousValue !== changes.isUnits.currentValue) {
      this.SetTextCantidadUnidad();
    }

  }

  SetTextCantidadUnidad() {
    this.textCantidadUnidad = this.isUnits ? "unidad" : "cantidad";
  }

  addFamily(family: PuntoapuntoFamilyDTO, segment: string, segmentDescription: string) {
    if (!this.selectedFamilies.some(x => x.IdSegment == family.IdSegment)) {
      let newSegment: FamilyGroupSelectionDTO = {
        IdSegment: family.IdSegment,
        Segment: segment,
        SegmentDescription: segmentDescription,
        Families: []
      }
      this.selectedFamilies.push(newSegment);
      this.addActiveTabsIds(newSegment);
    }

    let selectedSegment = this.selectedFamilies.find(x => x.IdSegment == family.IdSegment);

    let newFamily: FamilySelectionDTO = {
      IdSegment: selectedSegment.IdSegment,
      IdFamily: family.IdFamilyInt,
      Family: family.Family,
      Description: family.Description,
      PvpMin: null,
      PvpMax: null
    };

    let idx = selectedSegment.Families.findIndex(x => x.IdFamily == family.IdFamilyInt);

    if (idx > -1) {
      Swal.fire({
        title: 'Esta familia ya se ha seleccionado',
        text: "",
        icon: 'warning',
        buttonsStyling: false,
        customClass: {
          cancelButton: 'btn-yw me-2',
          confirmButton: 'btn btn-outline-secondary'
        },
        allowOutsideClick: false,
        cancelButtonText: '<i class="bi bi-x-lg"></i> Aceptar',
        cancelButtonColor: '#d33',
        reverseButtons: true,
        focusCancel: true
      });
    } else {

      selectedSegment.Families.push(newFamily);

      this.selectedFamilies.sort((a, b) => a.Segment.localeCompare(b.Segment));
      this.selectedFamilies.forEach(function (element) {
        element.Families.sort((a, b) => a.Family.localeCompare(b.Family));
      });
    }

    this.emitSelection();

  }

  addSegment(Segment: string, IdSegment: number, segmentDescription: string, pvpMin, pvpMax) {


    let idx = this.selectedSegments.findIndex(x => x.IdSegment == IdSegment);

    if (idx > -1) {

      Swal.fire({
        title: 'Este segmento ya se ha seleccionado',
        text: "",
        icon: 'warning',
        buttonsStyling: false,
        customClass: {
          cancelButton: 'btn-yw me-2',
          confirmButton: 'btn btn-outline-secondary'
        },
        allowOutsideClick: false,
        cancelButtonText: '<i class="bi bi-x-lg"></i> Aceptar',
        cancelButtonColor: '#d33',
        reverseButtons: true,
        focusCancel: true
      });
    } else {

      var newSegment = new SegmentGroupSelectionDTO();
      newSegment.IdSegment = IdSegment;
      newSegment.Segment = Segment;
      newSegment.SegmentDescription = segmentDescription;
      newSegment.PvpMin = pvpMin != "" ? pvpMin: null;
      newSegment.PvpMax = pvpMax != "" ? pvpMax: null;

      this.selectedSegments.push(newSegment);
    

      this.emitSelection();
    }



  }

  removeSegment(IdSegment: number) {

    this.selectedSegments = this.selectedSegments.filter(x => x.IdSegment != IdSegment);

    this.emitSelection();

  }

  removeFamilySegment(IdSegment: number) {

    this.selectedFamilies = this.selectedFamilies.filter(x => x.IdSegment != IdSegment);

    this.emitSelection();

  }

  removeFamily(family: FamilySelectionDTO) {
    Swal.fire({
      title: '¿Quieres eliminar esta familia?',
      text: "",
      icon: 'warning',
      buttonsStyling: false,
      customClass: {
        cancelButton: 'btn-yw me-2',
        confirmButton: 'btn btn-outline-secondary'
      },
      showCancelButton: true,
      allowOutsideClick: false,
      confirmButtonText: '<i class="fa fa-trash-o" aria-hidden="true"></i> Eliminar',
      cancelButtonText: '<i class="bi bi-x-lg"></i> Cancelar',
      cancelButtonColor: '#d33',
      reverseButtons: true,
      focusCancel: true
    }).then((result) => {
      if (result.value) {
        let selectedSegment = this.selectedFamilies.find(x => x.IdSegment == family.IdSegment);
        let idx = selectedSegment.Families.findIndex(x => x.IdFamily == family.IdFamily);
        if (idx > -1) {
          selectedSegment.Families.splice(idx, 1);
        }

        if (selectedSegment.Families.length == 0) {
          let idxSegment = this.selectedFamilies.findIndex(x => x.IdSegment == selectedSegment.IdSegment);
          if (idxSegment > -1) {
            this.selectedFamilies.splice(idxSegment, 1);
          }
        }
        this.emitSelection();
      }
    });
  }

  emitSelection() {
    this.onFamilySelected.emit(this.selectedFamilies);
    this.onSegmentSelected.emit(this.selectedSegments);
  }

  searchFamily() {

    const that = this;
    this.model = this.modelSearch.map(item => ({
      Segment: item.Segment,
      Familiy: item.Familiy.filter(family =>
        family.Family.toLowerCase().includes(that.familyFind.toLowerCase()) ||
        family.Description.toLowerCase().includes(that.familyFind.toLowerCase())
      )
    })).filter(item => item.Familiy.length > 0);
  }

  setActiveTabsIds() {
    const that = this;

    this.selectedFamilies.forEach(function (element) {
      that.activeTabsIds.push('selectedSegment' + element.IdSegment);
    });
  }


  addActiveTabsIds(segment) {
    this.activeTabsIds.push('selectedSegment' + segment.IdSegment);
  }



  showAddSegmentForm() {
    this.addSegmentFormIsVisible = !this.addSegmentFormIsVisible;
  }
}


